import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { handleKeyDown } from "../../../Common/FewCommonMethods";

export default function ModalBudget({
  price,
  setModalBudget,
  hitApi,
  handleInputBudget,
  title
}) {
  const initialValues = {
    price: price || "",
  };

  const validationSchema = Yup.object().shape({
    price: Yup.string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
  });

  const handleSubmit = (values) => {
    setModalBudget(false);
    hitApi();
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue }) => (
        <Form>
          <button
            onClick={() => setModalBudget(false)}
            className="btn close-button d-block"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <ModalBody>
            <h4>Edit {title ? title : 'Budget'} </h4>
            <div className="form-group">
              <label>Enter {title ? title : 'Budget'}</label>
              <Field
                className="form-control input"
                name="price"
                placeholder="Your price"
                onKeyDown={handleKeyDown}
                onChange={handleInputBudget}
              />
              <ErrorMessage name="price" component="div" className="error" />
            </div>
          </ModalBody>
          <div className="modal-footer ">
            <button className="btn" type="submit">
              Save
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
